import React from "react"
import FieldProto_ConditionForm from "../../../proto/render/condition/condition-form"

import FieldProto from "../../../proto/field-proto"
import FieldsFactory from "../../../fields-factory"
import {FieldType} from "../../../field-type"
import ConditionTypeSelector from "../../../proto/render/condition/condition-type-selector"
import FieldFormElementView from "../../../render/form-elemnent-view"

// const debug = "FieldString_ConditionForm"
const debug = false

export default class FieldString_ConditionForm extends FieldProto_ConditionForm {
    render() {
        let field: FieldProto = FieldsFactory.get({
            type    : FieldType.STRING,
            fieldId : 'value'
        })

        debug && console.log(debug, 'render', field)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                {field &&
                    <div className="flex-row-left-center m-l-10">
                        <FieldFormElementView className = "w-250 flex-no-shrink"
                                              field     = {field}
                                              model     = {{value: this.props.condition.value}}
                                              onChange  = {this.onChangeValue}/>
                    </div>}
            </>
        )
    }
}
